import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import { useState } from 'react'
import MyTableMoreIco from '../../UI/table/MyTableMoreIco'
import { Link } from 'react-router-dom'
import Status from '../../UI/status/Status'
import { getUserName } from '../../../helpers/user/UserHelper'
import { getDateAndTimeText } from '../../../helpers/date/dateHelper'
import InnerTable from '../../UI/table/inner/InnerTable'
import SupplyOrderItemsAgreeCount from '../../supply/supplyOrder/view/items/fields/SupplyOrderItemsAgreeCount'
import WriteOffActItemsTableShort from '../act/view/itemsShort/WriteOffActItemsTableShort'
import WriteOffActAgreesCount from './fields/agree/WriteOffActAgreesCount'

const WriteOffActItem = ({ writeOffAct }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
		<TableRow>
			<MyTableMoreIco 
				open={open}
				setOpen={setOpen}
			/>
			<TableCell align='center'>
				<Link to={`/write-off/acts/${writeOffAct.id}`}>
					{writeOffAct.id}
				</Link>
				{/* {supplyOrder.id} */}
			</TableCell>
			<TableCell align='center'>
				{
					<Status status={writeOffAct.status} />
					// supplyOrder.status
				}
			</TableCell>
            <TableCell align='center'>
				{
					getUserName({
						user: writeOffAct.user
					})
				}
			</TableCell>
			<TableCell align='center'>
				{
					writeOffAct.departmentType ? 
						writeOffAct.departmentType.name + ' - '
					: ''
				}
				{
					writeOffAct.department ? 
						writeOffAct.department.name
					: ''
				}
			</TableCell>
			<TableCell align='center'>
				{/* <SupplyOrderItemsAgreeCount */}
				<WriteOffActAgreesCount
					writeOffAct={writeOffAct} 
				/>
			</TableCell>
			{/* <TableCell align='center'>
				<SupplyOrderItemReceivedShort 
					isReceivedAll={supplyOrder.isReceivedAll}
				/>
			</TableCell> */}
			<TableCell align='center'>
				{
					getDateAndTimeText(writeOffAct.createdAt)
				}
			</TableCell>
			{/* <TableCell align="center" className='myTable__actions'>
				
			</TableCell> */}
		</TableRow>

		<InnerTable
			open={open}
		>
			<WriteOffActItemsTableShort 
				writeOffActItems={writeOffAct.items}
			/>
		</InnerTable>
	</>
  )
}

export default WriteOffActItem